import { render, staticRenderFns } from "./AttachedFileModal.vue?vue&type=template&id=3712e8dc&scoped=true"
import script from "./AttachedFileModal.vue?vue&type=script&lang=js"
export * from "./AttachedFileModal.vue?vue&type=script&lang=js"
import style0 from "./AttachedFileModal.vue?vue&type=style&index=0&id=3712e8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712e8dc",
  null
  
)

export default component.exports